import React, { ChangeEvent, ReactNode } from "react";
import { Redirect } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

// @mui/material
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from "@mui/material/IconButton";
import { withStyles, createStyles } from '@mui/styles';
import { Container, Grid, Button } from '@mui/material';
import MaterialButton from '@mui/material/Button';

// aquaguard
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI} from 'Utils/ApiHelper.js';
import { buildAPIGetLoggerSummaryModel, APIGetLoggerSummaryModel } from "models/APIGetLoggerSummaryModel";
import ConnectionsPanel from "../../components/Connections/ConnectionsPanel";
import ReadingsPanel from "../../components/Readings/ReadingsPanel";
import MultiLoggerGraph from '../Groups/MultiLoggerGraph';
import MultiLoggerGraphV2 from '../Groups/MultiLoggerGraphV2'
import EventsPanel from '../../components/Events/EventsPanel';
import LCLSummary from "components/DeviceSummary/LCLSummary"
import { APIGetLoggerReadingsModel } from "models/APIGetLoggerReadingsModel";
import AlarmsPanel from "../../components/Alarms/AlarmsPanel";

// DevExtreme Components
import { Accordion, Item, AccordionTypes } from 'devextreme-react/accordion';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { ScrollView } from 'devextreme-react/scroll-view';
import { Typography } from '@mui/material';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ImagesPanel from 'components/ImageUpload/ImagesPanel'
import MinimumNightFlow from 'components/MinimumNightFlow/MinimumNightFlow'
import UploadDialog from "../../components/ImageUpload/UploadDialog"
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import zIndex from "@mui/material/styles/zIndex";
import ConfigurationPanel from "../../components/Connections/ConfigurationsPanel";
import Comments from "../../components/Comments/Comments";
import { injectIntl, FormattedMessage, IntlShape } from 'react-intl';
import moment from 'moment'
import Loader from '../../Utils/Loader/NewLoader2025'
import { APIGetLoggerReportsModel } from '../../models/APIGetLoggerReportsModel';
import BatteryInfo from '../../components/BatteryInfo/BatteryInfo'
import { Image } from '../../models/ImageModel'
import ImageCopyModal from '../../components/ImageUpload/ImageCopyModal'
import { APIImageUpload, buildAPIImageUpload } from "models/APIImageUpload";
const style = createStyles(styles as Record<string, any>);



interface ReadingsState {
    state: {
        loading: boolean;
        readingsData: Array<APIGetLoggerReadingsModel>;
    };
}

interface Props {
    classes: {
        cardTitleWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: string;
        };
        search: string;
    };
    mapKey: string;
    intl: IntlShape
}


interface State {
    redirect: boolean;
    redirectPath: string | undefined;
    redirectProps: string | undefined;
    startDate: Date;
    endDate: Date;
    loggerType: string;
    serial: string;
    modelId: string;
    isLoading: boolean;
    allowBack: boolean;
    loggerIds: number[];
    exportDialog: boolean;
    exportType: string;
    exportData: boolean[];
    exportEnable: boolean;
    showMLGPopUp: boolean;
    siteName: string;
    isDormant: boolean;
    txFreq: number;
    imageCount: number;
    uploadDialogOpen: boolean;
    showMNF: boolean
    selectedItemIndex: number
    linkDates: boolean
    openDropDowns: Array
    showLinkDate: boolean
    loggerBySerialData: APIGetLoggerSummaryModel
    reportData: APIGetLoggerReportsModel
    loggerImages: Image[];
    copyModal: boolean
    numImages: number,
    imageData: APIImageUpload[],
    imageURLs: string[]
    originalImageData: Image[]
    availableCopyImages: APIImageUpload[]
    availableCopyImagesURLs: string[]
}

class NewLCLDeviceDetail extends React.Component<Props, State> {

    // REFs to the channel reading components for Data export
    ChannelMLGReadings: React.RefObject<ReadingsState>;

    timer: any = null;     // Check for all readings loaded ready for export

    getValueChangedHandler: (productIndex: any) => (e: any) => void;

    constructor(props: Readonly<Props>) {
        super(props);
 

        

        this.state = {
            redirect: false,
            redirectPath: undefined,
            redirectProps: undefined,
            startDate: moment().subtract(7, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(),
            endDate: moment().toDate(),
            loggerType: '',
            serial: '',
            modelId: '',
            isLoading: true,
            allowBack: true,
            loggerIds: [],
            exportDialog: false,
            exportType: "XLSX",
            exportData: [false, false, false, false, false],
            exportEnable: false,
            showMLGPopUp: false,
            siteName: "",
            isDormant: false,
            txFreq: 24,
            imageCount: 0,
            uploadDialogOpen: false,
            showMNF: false,
            selectedItemIndex: 0,
            linkDates: false,
            openDropDowns: [],
            showLinkDate: false,
            loggerImages: [],
            copyModal: false,
            numImages: 0,
            imageData: [],
            imageURLs: [],
            originalImageData: [],
            availableCopyImages: [],
            availableCopyImagesURLs: []

        };

        this.showMLGPopUp = this.showMLGPopUp.bind(this)
        this.hideMLGPopUp = this.hideMLGPopUp.bind(this)   
        this.toggleCopyModal = this.toggleCopyModal.bind(this)
        this.getImages = this.getImages.bind(this)

        this.ChannelMLGReadings = React.createRef();
    }

    //called from componentDidMount or say a periodic refresh timer
    getDeviceDataFromAPI = () => {
        const me = this;
        return;
    }

    blankFunction = function () {
        return undefined;
    };

    showMLGPopUp(): void {
        this.setState({ showMLGPopUp: true });
    }

    hideMLGPopUp(): void {
        this.setState({ showMLGPopUp: false });
    }


    /*
    //https://supportcenter.devexpress.com/ticket/details/t967161/accordion-how-to-expand-all-items-on-initialized
    handleAccordionInitialized = (e: any) => {
        const selectedAccordionItems: any = [];

        const items = e.component.option('items');

        //existing selected items
        this.state.selectedAccordionItems.forEach(item => {
            selectedAccordionItems.push(item);
        });

        //always show top 2 items details / readings
        selectedAccordionItems.push(items[0]);
        selectedAccordionItems.push(items[1]);

        this.setState({ selectedAccordionItems: selectedAccordionItems });
    }
    */

    /*
    componentDidMount(): void {
        this.setState({ isLoading: true });
        this.getDeviceDataFromAPI();
    }
    */

    componentDidMount(): void {
        // Get logger serial - either from location.state (link from React page), or query string (?serial=)
        this.reloadData()
        
    }

    reloadData(): void {
        let serial = "";
        let allowBack = true;

        if (this.props?.location?.state) {
            serial = this.props.location.state.serial;
        }

        else {
            serial = (this.props.location.search.split('='))[1];
            allowBack = false;
           
        }

        this.setState({ serial: serial, allowBack: allowBack });

        //get detail on logger here
        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/LoggerBySerial?serial=' + serial), {})
            .then(response => {
                const data = buildAPIGetLoggerSummaryModel(response);
                const txFreq = data.TransmissionFrequency == null ? 24 : data.TransmissionFrequency;
                let startDate = moment().toDate();

                sessionStorage.setItem('selectedLoggers', (data.Id + 500000).toString())
                startDate = moment().subtract(7, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();

                

                CallGetAPI(CreateUrl('/api/image/ImageCount?chariotId=' + data.Id), {})
                    .then(imageData => {

                        me.setState(
                            {
                                imageCount: imageData,
                            })

                    })
                    .catch(function () {
                        me.setState(
                            {
                                imageCount: 0,
                            })
                    });

                CallGetAPI(CreateUrl('/api/aquaguard/LoggerReportBySerial?serial=' + serial), {})
                    .then(reportData => {

                        this.setState({
                            reportData: reportData,
                            isLoading: false
                        })

                    })
                    .catch(function (error) {
                        console.error(error);
                    });

                me.setState({
                    loggerBySerialData: data,
                    loggerType: data.Model,
                    modelId: data.ModelId,
                    loggerIds: [data.Id + 500000],       // Chariots have Id offset by 500000 for LoggerDetailsByIdList
                    siteName: data.SiteName,
                    isDormant: data.Dormant,
                    txFreq: txFreq,
                    startDate: startDate
                    
                });
                sessionStorage.setItem('selectedLoggers', (data.Id + 500000).toString())
            })

            .catch((error: Error) => {
                me.setState(
                    {
                        loggerType: 'unknown'
                    })
                console.error("Unauthorized!:{0}", error)
            });

        
        CallGetAPI(CreateUrl('/api/aquaguard/Companies'), {})
            .then(companies => {
                if (sessionStorage.getItem('companyId') !== '0') {
                    const currentCompany = companies.filter(item => item.id === parseInt(sessionStorage.getItem('companyId')))[0]
                    me.setState({ showMNF: currentCompany.calcMNF })
                } else {
                    me.setState({ showMNF: true })
                }
            })
            .catch(err => {
                console.error(err, 'cannot find current Company')
                
            })

        
    }

    componentWillUnmount():void {
        sessionStorage.setItem('selectedLoggers', "")
    }

    handleUploadButtonClick(): void  {
        this.setState({ uploadDialogOpen: !this.state.uploadDialogOpen})
    }

    handleDropDownOpen(e: AccordionTypes.SelectionChangedEvent): void {
        let openDropDowns
        if (e.addedItems.length > 0) {
            openDropDowns = [...this.state.openDropDowns, e.addedItems[0].title]
        }
        if (e.removedItems.length > 0) {
            openDropDowns = this.state.openDropDowns.filter(d => d !== e.removedItems[0].title)
        }

        if (openDropDowns.includes('Graph') && openDropDowns.includes('Minimum Night Flow')) {
            this.setState({ showLinkDate: true })
        } else {
            this.setState({ showLinkDate: false })
        }
        this.setState({ openDropDowns: openDropDowns})
    }

    handleDateUpdate(startDate, endDate): void {

        this.setState({
            startDate: startDate,
            endDate: endDate
        })
        
        
    }
 
    handleLCLSummaryLoad(loaded: boolean): void {
        if (loaded) {
            this.setState({ isLoading: false });
        }
    }

    componentDidUpdate(previousProps: any, previousState: any):void { 

          const  previousSerial = previousProps.location?.state?.serial;
        const currentSerial = this.props.location?.state?.serial;
        if (previousSerial !== currentSerial && currentSerial) {

            this.reloadData();
            this.setState({serial: currentSerial.toString()})
        }

        if (this.state.openDropDowns.includes('Images') && previousState.imageCount > 0 && this.state.imageData.length === 0) {
            this.getImages()
        }
    }

    getImages(): void {

        const me = this;
        let useAzure = false
        const imageData = new Array<APIImageUpload>();
        const imageURLData = new Array<string>();
        let imageCount = 0;
        CallGetAPI(CreateUrl('/api/image/Images?siteId=' + 0
            + "&loggerId=" +  0
            + "&chariotId=" + (sessionStorage.getItem('selectedLoggers') - 500000)
        ), {})
            .then(data => {
                for (let i = 0; i < data.length; i++) {
                    if (data[0].id.toString() == "00000000-0000-0000-0000-000000000000") {
                        useAzure = true;
                    }
                    if (useAzure == true) {
                        imageData.push(buildAPIImageUpload(data[i], me));
                        imageURLData.push(data[i].filename);
                        imageCount++;
                    }
                    else {
                        imageData.push(buildAPIImageUpload(data[i], me));
                        imageURLData.push(CreateUrl('/api/image/Images/' + data[i].id.toString()));
                        imageCount++;
                    }

                }

                setTimeout(() => {
                    this.setState({
                        numImages: imageCount,
                        imageData: imageData,
                        imageURLs: imageURLData,
                        originalImageData: data
                    });
                    this.getSiteImageURLs()
                }, 1000)
            })
            .catch(err => {
                console.error(err)
            })
    }

    getSiteImageURLs(): void {
        let useAzure = false
        const siteImageURLs: string[] = []
        const availableImageURL: string[] = []
        const availableImageData: APIImageUpload[] = []
        CallGetAPI(CreateUrl('/api/image/Images?siteId=' + this.state.reportData[0].siteid
            + "&loggerId=" + 0
            + "&chariotId=" + 0
        ), {})
            .then(data => {

                for (let i = 0; i < data.length; i++) {
                    if (data[0].id.toString() == "00000000-0000-0000-0000-000000000000") {
                        useAzure = true;
                    }
                    if (useAzure == true) {
                        siteImageURLs.push(data[i].filename);

                    }
                    else {
                        siteImageURLs.push(CreateUrl('/api/image/Images/' + data[i].id.toString()));
                        
                    }
                }
                this.state.imageURLs.forEach((img, idx) => {
                    if (!siteImageURLs.includes(img)) {
                        availableImageURL.push(img)
                        availableImageData.push(this.state.imageData[idx])
                    }
                    
                })
                this.setState({
                    availableCopyImages: availableImageData,
                    availableCopyImagesURLs: availableImageURL
                })
            })
            .catch(err => console.error(err))
    }

    toggleCopyModal():void {
        this.setState({ copyModal: !this.state.copyModal })
    }



    render(): ReactNode {
        const { classes, history, location, intl } = this.props;


        return (!this.state.redirect) ?
            (<div >

                {this.state.isLoading &&
                    <div style={{
                        position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
                    }}>
                        <Loader color={undefined } />
                    </div>
                }

                {!this.state.isLoading &&
                    <div>

                        <ImageCopyModal
                            show={this.state.copyModal}
                            loggerId={null}
                            lcLoggerId={this.state.loggerIds[0] - 500000}
                            siteId={this.state.reportData[0].siteid}
                            parent="lcLogger"
                            images={this.state.availableCopyImages}
                            imageURLs={this.state.availableCopyImagesURLs}
                            toggleCopyModal={this.toggleCopyModal}
                        />

                        <UploadDialog
                            show={this.state.uploadDialogOpen}
                            title={intl.formatMessage({id: "Upload Image"})}
                            siteId={0}
                            loggerId={this.state.loggerIds[0]}
                            onSubmit={(): void => {
                                this.setState({ uploadDialogOpen: false })
                                this.getImages()

                            }}
                            onCancel={(): void => this.setState({ uploadDialogOpen: false })}
                        />
                        {/* GRID FORMATTING using MUI https://mui.com/material-ui/react-grid */}
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                            {true && //this.state.totalLCLoggers < 1 &&

                                <Card>
                                    <CardHeader color="primary" className="view view-cascade d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                                        <div style={{ display: 'inline', height: '40px', width: '100%' }}>
                                            {this.state.allowBack && <IconButton
                                                style={{ display: 'inline', marginTop: -14 }}
                                                onClick={(): void => history.goBack()}
                                                size="large"><ArrowBackIcon style={{ fill: "white" }} /></IconButton>}
                                        <h4 style={{ display: 'inline' }} className={classes.cardTitleWhite}>{`${this.state.serial}`} {this.state.siteName !== 'Unassigned' ? `(${intl.formatMessage({ id: "Site" })}: ${this.state.siteName})` : ""}</h4>
                                        
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                    <Container
                                        style={{
                                            minWidth: "100%"
                                        }}
                                    >
                                        <div>
                                            <Accordion
                                                        collapsible={true}
                                                        multiple={true}
                                                        onSelectionChanged={(e) => this.handleDropDownOpen(e)}
                                                        selectedIndex={this.state.selectedItemIndex}
                                            >
                                                        <Item title={intl.formatMessage({ id: 'Device Overview' })} >
                                                    <div>
                                                                <LCLSummary
                                                                    serial={this.state.serial}
                                                                    mapKey={this.props.mapKey}
                                                                    reloadData={this.reloadData}
                                                                    loggerBySerialData={this.state.loggerBySerialData}
                                                                    reportData={this.state.reportData}

                                                                />
                                                    </div>
                                                </Item>
                                                
                                                        
                                                        <Item title={intl.formatMessage({ id: 'Graph' })} >
                                                <div>


                                                                <Popup
                                                                    id="popupMLG"
                                                                    visible={this.state.showMLGPopUp}
                                                                    title={`${intl.formatMessage({ id: "Logger Serial" })} ${this.state.serial}`}
                                                                    showTitle={true}
                                                                    showCloseButton={true}
                                                                    fullScreen={true}
                                                                    onHiding={this.hideMLGPopUp.bind(this)}
                                                                    closeOnOutsideClick={false}
                                                                    style={{zIndex: 1} }
                                                                >
                                                                    
                                                            <ScrollView
                                                                width='100%'
                                                                height='100%'
                                                                showScrollbar={'always'}
                                                            >
                                                                <div id="textBlock">
                                                                    {this.state.showMLGPopUp && <MultiLoggerGraphV2 ref={this.ChannelMLGReadings} showDates={false} startDateProps={this.state.startDate} endDateProps={this.state.endDate} location={{ state: { groupId: 0, loggers: this.state.loggerIds, showBackButton: false, site: null } }} history={{ goBack: this.blankFunction }} fullscreen={true} handleDateUpdate={(startDate, endDate): void => this.handleDateUpdate(startDate, endDate)} />}

                                                                </div>
                                                            </ScrollView>
                                                    </Popup>
                                                                
                                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                                    <div style={{width: "100%"} }>
                                                                        <MaterialButton style={{ float: "right", marginRight: "30px", width: "300px" }} color="secondary" variant="contained" onClick={this.showMLGPopUp}>{intl.formatMessage({ id: "Full Screen Graph" })}</MaterialButton>
                                                                    </div>
                                                                     <div>

                                                                        <MultiLoggerGraphV2 ref={this.ChannelMLGReadings} showDates={true} startDateProps={this.state.startDate} endDateProps={this.state.endDate} location={{ state: { groupId: 0, loggers: this.state.loggerIds, showBackButton: false, site: null } }} history={{ goBack: this.blankFunction }} fullscreen={false} handleDateUpdate={(startDate, endDate): void => this.handleDateUpdate(startDate, endDate)} />

                                                                    </div>
                                                        {/* PREVIOUSLY JUST READINGS -> <ReadingsPanel serials={[this.state.serial]} />*/}
                                                    </div>
                                                </div>
                                                </Item>
                                                {this.state.showMNF && this.state.serial && <Item title={intl.formatMessage({ id: "Minimum Night Flow" })} visible={true}>
                                                    <div>
                                                                <MinimumNightFlow serial={parseInt([this.state.serial][0])} siteId={null} startDateProps={this.state.startDate} endDateProps={this.state.endDate} showDateLink={this.state.showLinkDate} />
                                                    </div>
                                                </Item>}
                                                <Item title={intl.formatMessage({ id: 'Images' })} >
                                                            <div>
                                                                <MaterialButton
                                                                    variant="contained"
                                                                    onClick={(): void => this.handleUploadButtonClick()}
                                                                >
                                                                    {intl.formatMessage({ id: "Upload" })}
                                                                </MaterialButton>
                                                                {this.state.imageCount > 0 &&
                                                                    this.state.availableCopyImagesURLs.length > 0 && this.state.reportData[0].siteid && <MaterialButton
                                                                        variant="contained"
                                                                        color="secondary"
                                                                        style={{ marginLeft: 10 }}
                                                                        onClick={(): void => this.toggleCopyModal()}
                                                                    >
                                                                        {intl.formatMessage({ id: "Copy Images to Site" })}
                                                                    </MaterialButton>}

                                                                {this.state.numImages && this.state.numImages > 0 &&
                                                                    this.state.imageData && this.state.imageData.length > 0 &&
                                                                    <ImagesPanel
                                                                    loggerId={0}
                                                                    chariotId={this.state.loggerIds[0]}
                                                                    siteId={0}
                                                                    images={this.state.loggerImages}
                                                                    getImages={this.getImages}
                                                                    imageData={this.state.imageData}
                                                                    imageCount={this.state.numImages}
                                                                    imageURLs={this.state.imageURLs}
                                                                    />}
                                                        
                                                    </div>
                                                </Item>
                                                        <Item title={intl.formatMessage({ id: "Comments" })} >
                                                    <Comments lcLoggerId={this.state.loggerIds[0]} loggerId={null} siteId={null} />
                                                </Item>
                                                <Item title='Readings' visible={false}>
                                                    <div>
                                                        <ReadingsPanel serials={[this.state.serial]} />
                                                    </div>
                                                </Item>
                                                        <Item title={intl.formatMessage({ id: 'Alarms' })} visible={true}>
                                                    <div>
                                                        <AlarmsPanel serial={this.state.serial} />
                                                    </div>
                                                </Item>
                                                        <Item title={intl.formatMessage({ id: 'Connections' })} >
                                                    <div>
                                                        <ConnectionsPanel serials={[this.state.serial]}/>
                                                    </div>
                                                        </Item>
                                                        <Item title={intl.formatMessage({ id: 'Battery Info' })}>
                                                    <div>
                                                        <BatteryInfo loggerId={this.state.loggerIds[0] - 500000} serial={this.state.serial } />
                                                    </div>
                                                </Item>
                                                <Item title={intl.formatMessage({ id: "Events" })}>
                                                    <div>
                                                        <EventsPanel serials={[this.state.serial]} />
                                                    </div>
                                                </Item>
                                                <Item title={intl.formatMessage({ id: 'Configuration Updates' })} >
                                                    <div>
                                                        <ConfigurationPanel serial={this.state.serial} model={this.state.loggerType} />
                                                    </div>
                                                </Item>


                                            </Accordion>
                                        </div>
                                    </Container>

                                </CardBody>
                                </Card>

                                }
                            </Grid>
                        </Grid>
                    </div>
                }
            </div>)
            :
            (<Redirect push to={{
                pathname: this.state.redirectPath,
                state: this.state.redirectProps
            }} />);
    }
}
export default injectIntl(withStyles(style)(NewLCLDeviceDetail));